import { EditArea } from '../../Component/SlateCustom'
import { Row, Container } from 'react-bootstrap';
import { State } from './index';

export function Panel({ config: { color } }: { config: State }) {
    return <Row className='m-0 p-0' style={{ background: color }}>
        <Container><EditArea /></Container>
    </Row>
}